import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import PinkCTA from "./PinkCTA";

const Layout = ({ children }) => {
  return (
    <div className="relative z-10 min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <PinkCTA />
      <Footer />
    </div>
  );
};

export default Layout;
